import Ajax from 'global/od/Ajax';

export const experianEmailLookup = (emailInputValue, pageType) => {
	return Ajax({
		url: `/ajax/${pageType}/multi/about-you/validate/email`,
		method: 'POST',
		dataType: 'html',
		data: {
			emailId: emailInputValue,
		},
	});
};
